import { EntityFormType, EntityForm } from '../../interfaces/entity-form';
import { EntityFormGrid } from '../EntityFormGrid/EntityFormGrid';

export interface EntityFormGridsProps {
  template: EntityForm['template'];
  entity: EntityFormType;
  formDisabled: boolean;
}

export function EntityFormGrids({ template, entity, formDisabled }: EntityFormGridsProps) {
  return (
    <div data-id='entity-form-grids'>
      {template.map(grid => (
        <EntityFormGrid key={grid.id} grid={grid} entity={entity} formDisabled={formDisabled} />
      ))}
    </div>
  );
}
